import {ProjectSystemType} from "../project/types";

export type PinProject = {
    color       : number
    id          : ID
    name        : string
    systemType  : ProjectSystemType
}

export type PinTask = {
    id          : ID
    taskTypeId  : ID
    title       : string
}

export type PinUser = {
    companyId   : ID
    userId      : ID
}

export type PinDocument = {
    documentTypeId  : ID
    id              : ID
    name            : string
}

export enum PinType {
    PROJECT     = "project",
    TASK        = "task",
    USER        = "user",
    DOCUMENT    = "document",
    CUSTOM_VIEW = "customViewId",
}

export enum PinLocationTypes {
    HOME        = 'home',
    WORKSPACE   = 'workspace',
    // COMPANY     = 'company',
}

export type PinLocation = {
    type    : PinLocationTypes
    value?  : ID    // workspace ID when type is 'workspace'
}

export type PinData = {
    taskId?         : ID
    projectId?      : ID
    userId?         : ID
    organizationId? : ID
    chatId?         : ID
    customViewId?   : ID
    documentId?     : ID

    location?       : PinLocation
}
